import { FC, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import allDefectDataStore from "../../../store/allDefectData";
import { authStore } from "../../../store/authStore";
import defectCardsStore from "../../../store/defectCards";
import { IButton } from "../../../ui-kit";
import DefectTable from "./table";
import { useStatusMessage } from "../../../hooks/useStatusMessage";

import { IDefectDataProps } from "..";
import styles from "../Defect.module.scss";

const AllDefectData: FC<IDefectDataProps> = observer(
  ({ columns, openDefectCard }) => {
    const { data, sorter, isLoading, paginator, allData } = allDefectDataStore;
    const { sendDefectStatus, defectAgreedIsSending } = defectCardsStore;
    const { defectNotify } = authStore;
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    useEffect(() => {
      allData();
    }, [
      paginator.page,
      paginator.perPage,
      allDefectDataStore.filter.filterItems,
      sorter.changingKey,
    ]);

    useEffect(() => {
      if (defectAgreedIsSending.value) {
        allData();
      }
    }, [
      defectAgreedIsSending.value,
      paginator.page,
      paginator.perPage,
      allDefectDataStore.filter.filterItems,
      sorter.changingKey,
    ]);

    const parseChildren = (col) => {
      return {
        ...col,
        children:
          col.children?.length > 0
            ? col.children
                .filter((col) => columns.visibleCols.keys.includes(col.key))
                .map(parseChildren)
            : null,
      };
    };

    const openDefect = (id: string) => {
      if (openDefectCard) {
        openDefectCard(id);
      }
    };

    const cols = columns.columns
      .filter((col) => columns.visibleCols.keys.includes(col.key))
      .map(parseChildren);

    const rowSelection = defectNotify
      ? {
          selectedRowKeys,
          onChange: (newSelectedRowKeys) => {
            setSelectedRowKeys(newSelectedRowKeys);
            console.log(newSelectedRowKeys, '------newSelectedRowKeys')
          },
        }
      : null;

    const handleClickDefectAgreed = () => {
      // подтверждение
      const request = {
        ids: selectedRowKeys,
        isValid: true,
      };
      defectCardsStore.sendDefectAgreedAll(request);
      setSelectedRowKeys([]);
    };

    useStatusMessage(sendDefectStatus);

    // const rowSelection = defectNotify ? {
    //   selectedRowKeys: allDefectDataStore.selectedRows.keys,
    //   onChange: (selectedRowKeys) => {
    //     allDefectDataStore.selectedRows.setKeys([ ...selectedRowKeys ]);
    //   },
    // } : null;

    return (
      <>
        {authStore && defectNotify && (
          <IButton
            className={styles.Defect__buttonConfirm}
            onClick={handleClickDefectAgreed}
            disabled={
              selectedRowKeys.length === 0 || defectAgreedIsSending.value
            }
          >
            Подтвердить
          </IButton>
        )}
        <DefectTable
          columns={cols}
          dataSource={data}
          paginator={paginator}
          sorter={sorter}
          isLoading={isLoading.value}
          rowSelection={rowSelection}
          openDefect={openDefect}
        />
      </>
    );
  },
);

export default AllDefectData;
